module.exports = {
  apiBaseUrl: {
    logApi: "https://5n7h3e1iq8.execute-api.us-east-1.amazonaws.com/Prod",
    logApiID: "mlPMtlAbgj6xbKACmJp9iaQQs0nYeY941LHghrX0",
    claudeApi: "https://5n7h3e1iq8.execute-api.us-east-1.amazonaws.com/Prod",
    claudeApiID: "mlPMtlAbgj6xbKACmJp9iaQQs0nYeY941LHghrX0",
    kendraWebSocket:
      "wss://j34wiwfolj.execute-api.us-east-1.amazonaws.com/dev/",
    // AgentCore front door base.
    //
    // LEAVE EMPTY when this SPA is served from the same CloudFront
    // distribution as /api/* -- which is how the PoC distribution is built.
    // Empty means the adapter issues a relative request to /api/ask, so it is
    // same-origin: no CORS, no preflight, and the session cookie is
    // first-party so SameSite=Strict still sends it.
    //
    // Only set an absolute origin (no trailing slash) if the API really is on
    // a different host. Putting the app's own origin here would break as soon
    // as a custom domain is added in front of the distribution.
    agentApi: "",
  },
  features: {
    useKendraAPI: true, // Enable Kendra API in dev for testing
    // Routes chat through the AgentCore front door over HTTPS + SSE instead of
    // the API Gateway WebSocket. Both paths coexist, so this is the rollback
    // switch: set false and the WebSocket is used again with no redeploy.
    // agentApi is empty because the dev distribution serves the SPA at / and
    // the front door at /api/*, so the adapter issues a same-origin request.
    useHttpStreaming: true,
    // Promoted from the PoC: sign in through the AgentCore front door rather
    // than oidc-client-ts. The front door runs the OAuth flow (state + PKCE)
    // and keeps tokens server-side; the browser holds only an httpOnly session
    // cookie. See src/auth/session.js. Set to false to roll back to
    // oidc-client-ts and bearer tokens.
    //
    // Requires the dev distribution to route /api/* to the front door Lambda
    // and https://dev.iq.pay.tnsi.com/api/auth/callback to be registered on
    // the dev-tnspay-iq-app-client Cognito app client.
    useBffSession: true,
  },
  cognito: {
    authority:
      "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_bhsE2FqD8",
    clientId: "12comhftbdd0tq6n1o0kcto1rq",
    // Was "https://tns-iq-dev.auth.us-east-1.amazoncognito.com", which is the
    // hosted-UI domain of a DIFFERENT pool (us-east-1_EGijSFBEl,
    // tns-iq-dev-user-pool — the one apiConfigLocal.js uses). The `authority`
    // above points at us-east-1_bhsE2FqD8 (dev-tnspay-iq-user-pool), whose
    // domain is dev-tnspay-iq-auth. Verified against cognito-idp
    // describe-user-pool in account 885659967736.
    //
    // Only NavBar.js/App.js logout read this, which is why a mismatched value
    // went unnoticed: sign-in uses `authority` and worked fine.
    cognitoDomain: "https://dev-tnspay-iq-auth.auth.us-east-1.amazoncognito.com",
    logoutUri: "https://dev.iq.pay.tnsi.com/logout",
  },
  checkout: {
    checkoutApi:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/",
    hostedCheckoutEndpoint:
      "https://checkouttest.dev.paymentgateway.tnsi.com/uat/dist/index.js",
    terminalSaleEndpoint:
      "https://tljk7p4lu9.execute-api.us-east-1.amazonaws.com/dev/api/payments/terminal/sale",
  },
};


